import { t } from "@/i18n-js/instance";

import { DefaultFullPreview } from "../../..";
import type { ComponentLineProps } from "../types";
import { shouldExpandFirstPayment } from "../variants/helpers";

export const DiscountLine = ({ preview, options }: ComponentLineProps) => {
  if (
    !shouldExpandFirstPayment(preview) ||
    preview.first_payment.discount >= 0
  ) {
    return null;
  }

  return (
    <DefaultFullPreview.PreviewEntry
      label={t("paywall_checkout.coupon.discount")}
      value={preview.first_payment.formatted_discount}
      valueColor="text-green-700"
      dataTestId="checkout-form-preview-today-discount"
      {...options}
    />
  );
};
